import { Dispatch, SetStateAction, useState } from "react";
import { useWatches } from "../../../../../context/watchProvider";
import AdminButton from "../../../../core/admin/adminButton";
import { AdminLoading } from "../../../../core/admin/adminSpinner";
import { adminInputClass } from "../../../../core/admin/adminTextInput";
import { IWatch } from "../../watches/adminWatches";

export default function ImagesReorderer({ watch, setWatch, update }: { watch: IWatch | null, setWatch: Dispatch<SetStateAction<IWatch | null>>, update: () => void }) {

    const { updateWatch } = useWatches();
    const [loading, setLoading] = useState(false);

    const handleImgOrder = (idx: number, value: string) => {
        if(!watch?.id){
            return null;
        }
        let images = watch?.images;
        if(!images.length){
            return null;
        }
        if(value === ""){
            images[idx] = {...images[idx], order: 0};
        setWatch({...watch, id: watch?.id, images});
            return null;
        }
        if (!/^\d+$/.test(value)) {
            return null;
        }
        if(parseInt(value) > 99){
            return null;
        }
        images[idx] = {...images[idx], order: parseInt(value)};
        setWatch({...watch, id: watch?.id, images});
    }

    const saveOrder = async () => {
        if(!watch?.id){
            return null;
        }
        setLoading(true);
        await updateWatch(watch?.id, {images: watch?.images.sort((a: {order: number}, b: {order: number}) => a.order - b.order)});
        update();
        setLoading(false);
    }

    return (
        <div className="rounded-xl border border-gray-200 bg-gray-50 w-full p-4 flex flex-col gap-4">
            <p className="text-sm text-gray-600">Digite a posição de cada imagem (menor aparece primeiro) e clique em “Salvar ordem”.</p>
            {
                loading ?
                    <AdminLoading />
                    :
                    <div className="flex flex-wrap gap-4">
                        {
                            watch?.images?.length ?
                                watch.images.map((img: {imgUrl: string, cImgUrl: string, order: number}, idx: number) => (
                                    <div key={idx} className="w-32 h-32 rounded-xl border border-gray-200 bg-white relative">
                                        <div className="h-full w-full overflow-hidden rounded-xl">
                                            <img src={img?.cImgUrl} alt="relojo" className="h-full w-full object-cover" />
                                        </div>
                                        <input aria-label={`Posição da imagem ${idx + 1}`} inputMode="numeric" className={`${adminInputClass} absolute -top-2 -right-2 !w-12 h-9 !px-1 text-center font-bold shadow`} type="text" value={img?.order} onChange={e => handleImgOrder(idx, e.target.value)}/>
                                    </div>
                                ))
                                : null
                        }
                    </div>
            }
            <div className="flex justify-end">
                <AdminButton loading={loading} onClick={saveOrder}>Salvar ordem</AdminButton>
            </div>
        </div>
    )
}
